import { If } from 'tsx-control-statements/components';
import { Trans } from 'react-i18next';
import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';

import { getMinContainerHeight } from 'helpers/utils';

import { Text } from 'libComponents';
import StartPageFooter from 'components/StartPageFooter';
import GenderOptionBox from './subComponents/GenderOptionBox';
import GenderOption from './subComponents/GenderOption';

import styles from './Gender.module.css';

import { IGender } from 'types/commonInterfaces';
import { IGenderContainerProps } from './types';

const GenderContainer = (props: IGenderContainerProps): ReactElement => {
    const cx = classNames.bind(styles);

    const {
        genderData: { genders, title },
        pulseNumber,
        toNextPage,
        indexPage,
        loginLink,
        analytic,
    } = props;

    const selectGender = (gender: IGender) => toNextPage(gender);

    const containerStyles = cx({
        container: true,
        pulse: pulseNumber,
        indexPage: indexPage,
    });

    const loginClick = () => {
        analytic.customData('index__click', { event_action: 'text__header_login' });

        loginLink && (window.location.href = loginLink);
    };

    return (
        <>
            <div className={containerStyles} style={{ minHeight: getMinContainerHeight() }}>
                <Text type="h4" color="text-secondary" center mb={12}>
                    <Trans>{title}</Trans>
                </Text>
                <div className={styles.genderChoice}>
                    <GenderOptionBox>
                        {genders.map((genderOption, index) => (
                            <GenderOption
                                key={index}
                                onClick={() => selectGender(genderOption.sex)}
                                images={genderOption.images}
                                dataLocator={genderOption.dataLocator}
                                gender={genderOption.sex}
                                buttonSmall={window.innerWidth <= 767}
                                buttonTitle={genderOption.buttonTitle}
                            />
                        ))}
                    </GenderOptionBox>
                    <Text type="large-text" color="text-secondary-subdued" bold center mb={4}>
                        <Trans i18nKey="startPage.index.subTitle" />
                    </Text>
                </div>
                <div className={styles.indexFooterContainer}>
                    <StartPageFooter indexPage={indexPage} />
                </div>
                <If condition={indexPage}>
                    <button data-locator="StartLoginButton" onClick={loginClick} className={styles.loginLink}>
                        <Trans>Log in</Trans>
                    </button>
                </If>
            </div>
        </>
    );
};

export default GenderContainer;
